var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "confirm-mask",
      },
      [
        _c("div", { staticClass: "confirm-container relative" }, [
          _c("i", {
            staticClass: "el-icon-close absolute pointer",
            staticStyle: {
              right: "16px",
              top: "16px",
              "font-size": "20px",
              color: "#666666",
            },
            on: { click: _vm.close },
          }),
          _c("p", { staticClass: "title" }, [
            _vm._v("大模型根据您的指令生成报告"),
          ]),
          _c("div", { staticClass: "question-view" }, [
            _c("div", { staticClass: "current_radio relative" }, [
              _c(
                "div",
                { staticClass: "flex items-center justify-center type-radio" },
                [
                  _vm.questionText && _vm.documentName
                    ? [
                        _c(
                          "span",
                          {
                            class: { active: _vm.current === "input" },
                            on: {
                              click: function ($event) {
                                _vm.current = "input"
                              },
                            },
                          },
                          [_vm._v("手动输入")]
                        ),
                        _c("i", [_vm._v("|")]),
                        _c(
                          "span",
                          {
                            class: { active: _vm.current === "file" },
                            on: {
                              click: function ($event) {
                                _vm.current = "file"
                              },
                            },
                          },
                          [_vm._v("文件")]
                        ),
                      ]
                    : _vm._e(),
                  _vm.questionText && !_vm.documentName
                    ? [
                        _c(
                          "span",
                          {
                            class: { active: _vm.current === "input" },
                            staticStyle: { cursor: "text" },
                          },
                          [_vm._v("手动输入")]
                        ),
                      ]
                    : _vm._e(),
                  !_vm.questionText && _vm.documentName
                    ? [
                        _c(
                          "span",
                          {
                            class: { active: _vm.current === "file" },
                            staticStyle: { cursor: "text" },
                          },
                          [_vm._v("文件")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _c("div", { staticClass: "render-box" }, [
              _vm.current === "input"
                ? _c("p", [_vm._v(_vm._s(_vm.questionText))])
                : _vm._e(),
              _vm.current === "file"
                ? _c("p", [
                    _vm._v(
                      "大模型根据您上传的“" +
                        _vm._s(_vm.documentName) +
                        "”文件生成的报告，目前暂不支持文件预览。"
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }